// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"CustomTextInput_inputWrapper__2Ng6H","input":"CustomTextInput_input___AI6H"};